import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Modals, ProductFeedbackQuestionIds } from '@/constants';
import { AnalyticsService, EVENT_CONSTANTS } from '@/services';
import { uiActions, useSubmitProductFeedbackMutation } from '@/store';

import { AppModal } from '../AppModal';
import { ProductFeedbackModalContent } from './ProductFeedbackModalContent';
import { ProductFeedbackForm, Questions } from './types';
import { useDisplayProductFeedbackModal } from './useDisplayProductFeedbackModal';

export const ProductFeedbackModal = () => {
  const dispatch = useDispatch();
  const [submitCompleted, setSubmitCompleted] = useState(false);

  useDisplayProductFeedbackModal();

  const [form, setForm] = useState<ProductFeedbackForm>({
    [ProductFeedbackQuestionIds.sentiment]: undefined,
    [ProductFeedbackQuestionIds.isRecommended]: undefined,
    [ProductFeedbackQuestionIds.recommendReason]: undefined,
    [ProductFeedbackQuestionIds.suggestions]: undefined,
    [ProductFeedbackQuestionIds.followUpEmail]: undefined,
  });

  const [submitProductFeedbackRequest] = useSubmitProductFeedbackMutation();

  const closeModal = () => {
    setSubmitCompleted(false);
    dispatch(uiActions.closeActiveModal());
  };

  const submitFeedback = async ({
    isDismissed = false,
  }: {
    isDismissed?: boolean;
  }) => {
    const payload = {
      responses: Object.values(Questions).map(question => ({
        ...question,
        answer: form[question.questionId],
      })),
      isDismissed,
    };

    AnalyticsService.productFeedback({
      productFeedbackForm: form,
      isDismissed,
      referrer: {
        component: EVENT_CONSTANTS.COMPONENT.MODAL,
        modalName: Modals.PRODUCT_FEEDBACK,
      },
    });

    if (!submitCompleted) {
      await submitProductFeedbackRequest(payload);
    }

    if (isDismissed) {
      closeModal();
    } else {
      setSubmitCompleted(true);
    }
  };

  return (
    <AppModal
      modalName={Modals.PRODUCT_FEEDBACK}
      maxWidth={false}
      scroll="paper"
      transparentBackground
      onClose={() => submitFeedback({ isDismissed: true })}>
      <ProductFeedbackModalContent
        form={form}
        setForm={setForm}
        submitFeedback={submitFeedback}
        closeModal={closeModal}
      />
    </AppModal>
  );
};
